import React, { useRef } from 'react';
import './map.css';
import Layout from '../components/layout';
import { useGsapAnimations } from '../hooks/useGsapAnimations';

const Map = () => {
  const vrMapUrl = `${process.env.PUBLIC_URL}/vr-map.html`;
  const pageRef = useRef(null);

  useGsapAnimations(pageRef);

  return (
    <Layout>
      <div className="vr_map" ref={pageRef} data-gsap-intro>
        <iframe
          className="vr_map_frame"
          src={vrMapUrl}
          title="Techne VR map"
          allow="fullscreen; xr-spatial-tracking; gyroscope; accelerometer"
          allowFullScreen
        />
      </div>
    </Layout>
  );
};

export default Map;
